import React, { useEffect, useState } from 'react';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import { Badge, Container, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Picklist from '../../Picklist';
import * as Common from "../../Common";
import AsyncSelect from 'react-select/async';
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import $ from "jquery";
import { faEye, faCopy } from '@fortawesome/free-regular-svg-icons';
import FaView from '../../FaView';
import Tran_data_unlock_request from '../../Tran_data_unlock_request';
import CancelDialog from '../../CancelDialog';
import ActivityLog from '../../ActivityLog';

function Tran_cross_knockoff_updated() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');

    const [userRight, setUserRight] = useState([]);
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [hdrLocation, setHdrLocation] = useState(null);
    const [radioType, setRadioType] = useState("N");
    const [scrMode, setScrMode] = useState("");
    const [nDate, setNDate] = useState(new Date())
    const [hdrLocationName, setHdrLocationName] = useState("");
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrDate, setHdrDate] = useState("");
    const [nAmount, setNAmount] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [flag, setFlag] = useState("D");
    const [ledgerValue, setLedgerValue] = useState(null);
    const [grpCode, setGrpCode] = useState("");
    const [accCode, setAccCode] = useState("");
    const [isKnockOff, setIsKnockOff] = useState("0");

    const [knockoffValue, setKnockoffValue] = useState(null);
    const [nLocation, setNLocation] = useState(null);
    const [nLocatinCode, setNLocatinCode] = useState("");
    const [nLocationName, setNLocationName] = useState("");

    const [crAccCode, setCrAccCode] = useState("");
    const [crGrpCode, setCrGrpCode] = useState("");
    const [crFlag, setCrFlag] = useState("C");
    const [crKnockoffValue, setCrKnockoffValue] = useState(null);
    const [crLedgerValue, setCrLedgerValue] = useState(null);

    const [crIsKnockOff, setCrIsKnockOff] = useState("0");

    const [crLocation, setCrLocation] = useState(null);
    const [crLocationCode, setCrLocationCode] = useState("");
    const [hdrData, setHdrData] = useState([]);
    const [prevAmount, setPrevAmount] = useState("0");

    const [billNum1, setBillNum1] = useState("");
    const [billNum2, setBillNum2] = useState("");

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);

    const [srnoFrom, setSrnoFrom] = useState("");
    const [srnoTo, setSrnoTo] = useState("");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [narration, setNarration] = useState("");
    const [randomNum, setRandomNum] = useState("");

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [unlockRequestType, setUnlockRequestType] = useState("");

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [bookList, setBookList] = useState([]);
    const [counter, setCounter] = useState(0);
    const [crKnockoffAmount, setCrKnockoffAmount] = useState("0");
    const [tempLineNo, setTempLineNo] = useState(1);
    const [totalDebit, setTotalDebit] = useState("0");
    const [totalCredit, setTotalCredit] = useState("0");
    const [totalDifference, setTotalDifference] = useState("0");

    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);
    const [hdrDateYmd, setHdrDateYmd] = useState("");

    useEffect(() => {
        Common.getActiveBranch().then(response => {
            response != null && handleLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_CROSS_KNOCKOFF_UPDATED'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/');
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserCancelBillRight(resp);
            }
        });
    }, []);


    const handleLocationChange = (value) => {
        setHdrLocation(value);
        setNLocation(value);
        var v = value.id.split("^");
        setNLocatinCode(v[1]);
        setNLocationName(v[2]);
        setHdrLocationName(v[2]);
        setHdrData([]);
        sessionStorage.activeBranch = v[1];
    }

    const addNewForm = () => {
        var d = Common.dateYMD(nDate);
        var today = Common.dateYMD(new Date());
        if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } else {
            if (d == today) {
                addNewFormResetFields();
            } else {
                const obj = {
                    billdate: d,
                    location: nLocatinCode,
                    type: 'CRKNF'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = () => {
        setScrMode("A");
        setHdrSrno("0");
        setHdrDate(Common.dateDMY(nDate));
        setFlag("C");
        setCrFlag("D");
        setLedgerValue(null);
        setCrLedgerValue(null);
        setKnockoffValue(null);
        setCrKnockoffValue(null);
        setCrLocation(null);
        setNAmount("");
        setNarration("");
        setRandomNum(Common.getRandomString(15));
        setTempLineNo(1);
        setBookList([])
        setTotalCredit('0');
        setTotalDebit('0');
        setTotalDifference('0');
        setHdrDateYmd("");
    }

    const listCrossFa = () => {
        var msg = [];
        var i = 0;
        var d = Common.dateYMD(srnoFrom);
        if (radioType === "S" && (srnoFrom.trim() == "" || srnoTo.trim() === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (srnoFrom === "" ? "From Srno" : "");
            msg[i++] = (srnoTo === "" ? "To Srno" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (radioType === "D" && (fromDate === null || toDate === null)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate === null ? "From Date" : "");
            msg[i++] = (toDate === null ? "To Date" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            $(".loader").show();
            const obj = {
                type: "CRKNF",
                srnoFrom: srnoFrom,
                srnoTo: srnoTo,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                radioType: radioType,
                location: nLocatinCode
            }
            Common.callApi(Common.apiCrossKnockoffupdated, [sid, "listdata", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setHdrData(resp.data);
            });
        }
    }

    const btnEditRequest = () => {
        setScrMode("E");
    }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            flag: resp.thrk_flag_1,
            ledgerValue: { id: resp.a1id, label: resp.a1label },
            // knockoffValue: knockoffValue,
            grpCode: resp.grpcode1,
            accCode: resp.acctcode1,
            amount: resp.thrk_amount,
            narration: resp.thrk_narration,
        };
        setCompareData([obj2]);
    }
    const fillViewForm = (item) => {
        $(".loader").show();
        setHdrSrno(item.thrk_srno);
        setScrMode("Q");
        const obj = {
            srno: item.thrk_srno,
            type: item.thrk_type,
            loc1: item.thrk_loc_1,
            flag1: item.thrk_flag_1,
            grpcode1: item.thrk_group_1,
            acccode1: item.thrk_account_1,
            loc2: item.thrk_loc_2,
            flag2: item.thrk_flag_2,
            grpcode2: item.thrk_group_2,
            acccode2: item.thrk_account_2,
            date: item.thrk_date,
        }
        Common.callApi(Common.apiCrossKnockoffupdated, [sid, 'viewdata', JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            let resp = res.data[0];
            fillViewCompareObject(resp);
            handleLocationChange({ id: resp.e1id, label: resp.e1label });
            setCrLocation(null);
            setFlag(resp.thrk_flag_1);
            setCrFlag("D");
            setLedgerValue({ id: resp.a1id, label: resp.a1label });
            setCrLedgerValue(null);
            setGrpCode(resp.grpcode1);
            setAccCode(resp.acctcode1);
            setCrGrpCode("");
            setCrAccCode("");
            setNAmount(resp.thrk_amount);
            setPrevAmount(resp.thrk_amount);
            setHdrDate(resp.thrk_date);
            setBookList(res.crdata);
            calculateTotal(res.crdata);
            setHdrDateYmd(resp.thrk_date_ymd);
            if (res.knockoff_1 != "") {
                setKnockoffValue(res.knockoff_1);
                let a = res.knockoff_1.id.split("^");
                setBillNum1(a[2] + " " + a[3]);
            } else {
                setBillNum1("");
                setKnockoffValue(null);
            }
            if (res.knockoff_2 != "") {
                setCrKnockoffValue(null);
                setBillNum2("");
                // setCrKnockoffValue(res.knockoff_2);
                // let a = res.knockoff_2.id.split("^");
                // setBillNum2(a[2] + " " + a[3]);
            }
            else {
                setCrKnockoffValue(null);
                setBillNum2("");
            }
            setTempLineNo(res.crmaxlineno);
            setNarration(resp.thrk_narration);
            setRandomNum(resp.random_rum);
        });
    }

    const saveData = () => {
        let msg = [];
        let i = 0;
        const knockoffvalues = knockoffValue.id.split('^');
        console.log("this is ", knockoffvalues[8], nAmount)
        if (ledgerValue == null || knockoffValue === null
            // || ((nAmount * 1) > (knockoffvalues[8] * 1))
            || narration.trim() === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue === null ? "Ledger" : "");
            msg[i++] = (knockoffValue === null ? "Select Knock Off" : "");
            // msg[i++] = (((nAmount * 1) > (knockoffvalues[8] * 1)) ? "Amount" : "");
            msg[i++] = (narration.trim() === "" ? "Narration" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            $(".loader").show();
            const obj = {
                srno: hdrSrno,
                type: 'CRKNF',
                flag: flag,
                nLocatinCode: nLocatinCode,
                ledgerValue: ledgerValue,
                knockoffValue: knockoffValue,
                crFlag: crFlag,
                crLocationCode: crLocationCode,
                crLedgerValue: crLedgerValue,
                crKnockoffValue: crKnockoffValue,
                grpCode: grpCode,
                accCode: accCode,
                crGrpCode: crGrpCode,
                crAccCode: crAccCode,
                hdrDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(nDate),
                amount: Math.abs(nAmount),
                prevAmount: prevAmount,
                srnoFrom: srnoFrom,
                srnoTo: srnoTo,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                radioType: radioType,
                location: nLocatinCode,
                narration: narration,
                bookList: bookList,
                knockoff_location: knockoffvalues[1],
                knockoff_type: knockoffvalues[2],
                knockoff_srno: knockoffvalues[3],
                knockoff_lineno: knockoffvalues[4]
            }
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (userRight.edit === "1" && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'CRKNF', nLocatinCode));
            }
            Common.callApi(Common.apiCrossKnockoffupdated, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.msg == "1") {
                    setScrMode("");
                    setHdrData(resp.data);
                    setTranAuditTrail([]);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }
    // const saveData = () => {
    //     let msg = [];
    //     let i = 0;
    //     const knockoffvalues = knockoffValue.id.split('^'); 
    //     const obj = {
    //         srno: hdrSrno,
    //         location: knockoffvalues[1],
    //         knockoff_type: knockoffvalues[2],
    //         knockoff_srno: knockoffvalues[3],
    //         knockoff_lineno: knockoffvalues[4]
    //     }
    //     Common.callApi(Common.apiCrossKnockoffupdated, [sid, "getPreviousKnockoff", JSON.stringify(obj)], result => {
    //         let previousAmount = JSON.parse(result);
    //         finalsavedata(previousAmount);
    //     });
    // }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const handleFlagChange = (v) => {
        setFlag(v);
        setKnockoffValue(null);
    }

    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        const account = value.id.split('^');
        setGrpCode(account[1]);
        setAccCode(account[2]);
        setKnockoffValue(null);
        const obj = {
            groupCode: account[1],
            flag: flag == "C" ? "D" : "C"
        }
        Common.callApi(Common.apiCrossKnockoffupdated, [sid, "checkknockoff", JSON.stringify(obj)], result => {
            const res = JSON.parse(result);
            setIsKnockOff(res.isknockoff);
        });
    }

    const handleKnockoffValue = (value) => {
        setKnockoffValue(value);
        const knockoff = value.id.split('^');
        // setNAmount(knockoff[8]);
    }

    const handleNewLocationChange = (value) => {
        setNLocation(value);
    }

    const handleCrLocationChange = (value) => {
        setCrLocation(value);
        setCrLocationCode(value.id.split("^")[1]);
        setCrKnockoffValue(null);
    }

    const handleCrFlagChange = (v) => {
        setCrFlag(v);
        setCrKnockoffValue(null);
    }

    const handleCrLedgerValue = (value) => {
        setCrLedgerValue(value);
        const account = value.id.split('^');
        setCrGrpCode(account[1]);
        setCrAccCode(account[2]);
        setCrKnockoffValue(null);
        const obj = {
            groupCode: account[1],
            flag: crFlag == "C" ? "D" : "C"
        }
        Common.callApi(Common.apiCrossKnockoffupdated, [sid, "checkknockoff", JSON.stringify(obj)], result => {
            const res = JSON.parse(result);
            setCrIsKnockOff(res.isknockoff);
        });
    }

    const handleCrKnockoffValue = (value) => {
        setCrKnockoffValue(value);
        const knockoff = value.id.split('^');
        setCrKnockoffAmount(knockoff[8]);
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: nLocatinCode, trannumber: hdrSrno, type: 'CRKNF' });
    }

    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = hdrDate.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'CRKNF',
            pageright: 'TRAN_CROSS_KNOCKOFF_UPDATED',
            location: nLocatinCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'CRKNF', trannumber: hdrSrno, location: nLocatinCode, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'CRKNF',
            location1: nLocatinCode,
            location2: crLocationCode,
            srno: hdrSrno,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }
    const handleAdd = () => {
        console.log(crKnockoffValue);
        let msg = [];
        let i = 0;
        if (crLocation == null || crLedgerValue == null || crKnockoffValue === null || (crKnockoffAmount === "" || crKnockoffAmount === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (crLocation == null ? "Location " : "");
            msg[i++] = ((crKnockoffAmount === "" || crKnockoffAmount === "") ? " Crossknockoff Amount" : "");
            msg[i++] = (crKnockoffValue === null ? "Crossknockoff Knockoff value ." : "");
            msg[i++] = (crLedgerValue == null ? "Crossknockoff Account . " : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            const crossKnockoffValues = crKnockoffValue.id.split('^');
            let amt = crKnockoffAmount;
            if (flag == 'C') {
                if (crKnockoffAmount > 0) {
                    amt = -1 * crKnockoffAmount;
                }
            } else {
                if (crKnockoffAmount < 0) {
                    amt = -1 * crKnockoffAmount;
                }
            }
            const obj = {
                TabType: "Info",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TLoc: nLocatinCode,
                TType: 'CRKNF',
                uniquekey: Common.getRandomString(15),
                tfd_location: crossKnockoffValues[1],
                tfd_type: crossKnockoffValues[2], // CRKNF
                tfd_srno: crossKnockoffValues[3], // 0, 9
                tfd_line_no: crossKnockoffValues[4], // 12345
                tfd_knockoff_type: crossKnockoffValues[2],
                tfd_knockoff_srno: crossKnockoffValues[3],
                tfd_knockoff_lineno: crossKnockoffValues[4],
                tfd_group: crGrpCode,
                tfd_account: crAccCode,
                tfd_amount: amt,
                tfd_flag: crossKnockoffValues[9] == 'D' ? 'C' : 'D',
                tfd_date: Common.dateYMD(nDate),
                mvli_ledger_name: crossKnockoffValues[10],
                randomString: randomNum,
                delny: 'Y',
                tfd_1type: 'CRKNF',
                tfd_1line_no: tempLineNo,
                tfd_1srno: 1,
            }
            Common.callApi(Common.apiCrossKnockoffupdated, [sid, 'addknockoffSingle', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                calculateTotal(resp);
                setBookList(resp);
            })
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj]);
            }
            // setBookList(Common.arrayAddItem(bookList, obj));
            setTempLineNo(tempLineNo + 1);
            setCrKnockoffValue(null)
            setCounter(counter + 1);
            setCrKnockoffAmount("0")
        }
    }
    const handleDelete = (obj) => {
        console.log(obj);
        // if (scrMode == 'E') {
        if (obj.tfd_knockoff_srno != null && obj.tfd_knockoff_srno > 0) {
            const object = {
                location: obj.tfd_location,
                type: obj.tfd_type,
                srno: hdrSrno,
                lineno: obj.tfd_line_no,
                amt: obj.tfd_amount < 0 ? -1 * obj.tfd_amount : obj.tfd_amount,
                randomString: randomNum,
                tfd_1type: obj.tfd_1type,
                tfd_1line_no: obj.tfd_1line_no,
                tfd_1srno: obj.tfd_1srno
            }
            $(".loader").show();
            Common.callApi(Common.apiCrossKnockoffupdated, [sid, 'canDelete', JSON.stringify(object)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.isdeletable == "0") {
                    setMsgBox(true);
                    setMsgText("Cannot delete, amount already knocked off.");
                } else {
                    const itemToDelete = bookList.find(item => item.uniquekey === obj.uniquekey);
                    if (itemToDelete) {
                        const formattedItem = {
                            TabType: "Info",
                            ALineNo: tranAuditTrail.length + 1,
                            AType: "D",
                            TLoc: nLocatinCode,
                            TType: 'CRKNF',
                            tfd_location: itemToDelete.tfd_location,
                            tfd_type: itemToDelete.tfd_type,
                            tfd_srno: itemToDelete.tfd_srno,
                            tfd_line_no: itemToDelete.tfd_line_no,
                            tfd_knockoff_type: itemToDelete.tfd_knockoff_srno,
                            tfd_knockoff_srno: itemToDelete.tfd_knockoff_srno,
                            tfd_knockoff_lineno: itemToDelete.tfd_lineno,
                            tfd_group: itemToDelete.tfd_group,
                            tfd_account: itemToDelete.tfd_account,
                            tfd_amount: itemToDelete.tfd_amount,
                            tfd_flag: itemToDelete.tfd_flag,
                            tfd_date: itemToDelete.tfd_date,
                            tfd_1type: 'CRKNF',
                            tfd_1line_no: itemToDelete.tfd_1line_no,
                            tfd_1srno: itemToDelete.tfd_1srno,
                        };
                        if (userRight.edit === "1" && scrMode === 'E') {
                            setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                        }
                    }
                    setBookList(resp.resarray);
                    // setBookList(Common.arrayRemoveItem(bookList, "uniquekey", obj.uniquekey));
                    setCounter(counter - 1);
                    calculateTotal(resp.resarray);
                }
            });
        } else {
            const itemToDelete = bookList.find(item => item.uniquekey === obj.uniquekey);
            if (itemToDelete) {
                const formattedItem = {
                    TabType: "Info",
                    ALineNo: tranAuditTrail.length + 1,
                    AType: "D",
                    TLoc: nLocatinCode,
                    TType: 'CRKNF',
                    tfd_location: itemToDelete.tfd_location,
                    tfd_type: itemToDelete.tfd_type,
                    tfd_srno: itemToDelete.tfd_srno,
                    tfd_line_no: itemToDelete.tfd_line_no,
                    tfd_knockoff_type: itemToDelete.tfd_knockoff_srno,
                    tfd_knockoff_srno: itemToDelete.tfd_knockoff_srno,
                    tfd_knockoff_lineno: itemToDelete.tfd_lineno,
                    tfd_group: itemToDelete.tfd_group,
                    tfd_account: itemToDelete.tfd_account,
                    tfd_amount: itemToDelete.tfd_amount,
                    tfd_flag: itemToDelete.tfd_flag,
                    tfd_date: itemToDelete.tfd_date,
                    tfd_1type: 'CRKNF',
                    tfd_1line_no: itemToDelete.tfd_1line_no,
                    tfd_1srno: itemToDelete.tfd_1srno,


                };
                if (userRight.edit === "1" && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                }
            }
            setBookList(Common.arrayRemoveItem(bookList, "uniquekey", obj.uniquekey));
            setCounter(counter - 1);
            calculateTotal(bookList);
        }
    }
    const calculateTotal = (list, src = "") => {
        console.log("me andar aaya bhu ")
        let totalDebt = 0;
        let totalCred = 0;
        let i;
        for (i = 0; i < list.length; i++) {
            let amt = 0;
            if (list[i].tfd_reftype != 'GB') {
                if (list[i].tfd_flag == 'D') {
                    if (list[i].tfd_amount < 0) {
                        amt = -1 * list[i].tfd_amount;
                    } else {
                        amt = list[i].tfd_amount;
                    }
                    totalDebt = totalDebt + amt * 1;
                } else {
                    if (list[i].tfd_amount > 0) {
                        amt = -1 * list[i].tfd_amount;
                    } else {
                        amt = list[i].tfd_amount;
                    }
                    totalCred += amt * 1;
                }
            }
        }
        console.log(totalDebt);
        console.log(totalCred);
        setTotalDebit(totalDebt);
        setTotalCredit(totalCred);
        let totalDiff = totalDebt + totalCred;
        setTotalDifference(Number(totalDiff).toFixed(2));
        setNAmount(Number(totalDiff).toFixed(2));
        if (totalDiff < 0) {
            if (src === "") setFlag('D');
            setNAmount(-1 * totalDiff);
        } else if (totalDiff == 0) {
            setNAmount("");
        } else {
            if (src === "") setFlag('C');
            setNAmount(totalDiff);
        }
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "CRKNF", trannumber: hdrSrno, trancategory: "T", location: nLocatinCode });
    }
    function copyNarrationValue(val) {
        const narration = val?.label?.split(' ')[7]?.split(':')[1]?.split("^")?.join(' ');
        navigator.clipboard.writeText(narration || '');
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col><h2>Cross KnockOff
                        {/* <span><Badge bg="secondary" className="handCursor" title ="1.Able to crossknockoff bill of single bill to multiple bills.</br>
                                                                         2.Rules...</br>
                                                                         - Total Amount on top right corner(disabled) should be less then or equal to total amount </br>
                                                                          of total bills added corrosponding to the knockoff bill.</br>
                                                                         - You can able to delete all crossknockoff bill from the grid while edit/save the specific entry.</br>
                                                                         -You can able to crossknockoff specific amount from specific bill .(Select the crossknockoffBill </br>
                                                                          amonut from bill will automatically fetched ,then you will able to edit the amount shown in amount (non disabled) box.)" >Information</Badge></span> */}
                    </h2></Col>

                    <hr />
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "20px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" selected />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={hdrLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={(value) => handleLocationChange(value)}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={nDate}
                                                    onChange={(date) => setNDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={10} value={srnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={10} value={srnoTo} onChange={e => Common.validateNumValue(e.target.value, setSrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={fromDate}
                                                            onChange={(date) => setFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={toDate}
                                                            onChange={(date) => setToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" && (radioType !== "N" && radioType !== "R") ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={listCrossFa}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.add === "1" && radioType === "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={addNewForm}>Add New</Button> : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped bordered>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Srno</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Loc 1</th>
                                            <th>Loc 2</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            hdrData.map(item => (
                                                <tr key={item.thrk_srno}>
                                                    <td>
                                                        <span className='handCursor colorThemeBlue' onClick={() => fillViewForm(item)}>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.thrk_srno}</td>
                                                    <td>{item.thrk_date}</td>
                                                    <td>{item.thrk_amount}</td>
                                                    <td>{item.thrk_loc_1} {item.thrk_loc_1_name}</td>
                                                    <td>{item.thrk_loc_2} {item.thrk_loc_2_name}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>&nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>
                                            </>
                                            : null
                                    }
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                    {(userCancelBillRight.query === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{hdrLocationName} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='col-md-3 col-6' style={{ textAlign: "right" }}>
                                    <Form.Group>
                                        <Form.Control
                                            value={nAmount}
                                            maxLength={Common.maximumLength}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setNAmount)}
                                            placeholder="Amount"
                                            disabled={true}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {/* -------------------- Allowed Location ------------------- */}
                            {
                                scrMode === "Q" &&
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>KnockedOff Bill : <b>{billNum1}</b></Form.Label>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={nLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={(value) => handleNewLocationChange(value)}
                                            isDisabled
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Cr/Dr<span className="text-danger">*</span></Form.Label>
                                        <Form.Select disabled={scrMode === "Q"} value={flag} onChange={(e) => handleFlagChange(e.target.value)} required>
                                            <option value="C">Credit</option>
                                            <option value="D">Debit</option>
                                        </Form.Select>
                                    </Form.Group>

                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ledgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, nLocatinCode)} // location = 1 , 2
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLedgerValue}
                                            isDisabled={scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                scrMode !== "Q" &&
                                <>
                                    <Row>
                                        <Col className='col-12'>
                                            <Form.Group>
                                                <Form.Label>Knockoff<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={knockoffValue}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchKnockoffPicklist(search, nLocatinCode, `${flag}^${grpCode}^${accCode}^${Common.dateYMD(nDate)}^${randomNum}`)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleKnockoffValue}
                                                    formatOptionLabel={Picklist.knockOffFormatOptionLabel}
                                                    components={{ Menu: Picklist.knockkOffMenu }}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Narration : {knockoffValue?.label?.split(' ')[7]?.split(':')[1]?.split("^")?.join(' ')}
                                            <span className='colorThemeBlue' onClick={() => copyNarrationValue(knockoffValue)}>
                                                <FontAwesomeIcon icon={faCopy} />
                                            </span>
                                        </Col>

                                    </Row>
                                </>

                            }
                            <hr />
                            {/* -------------------- Cross Location ------------------- */}
                            {
                                scrMode === "Q" &&
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Knocked Off Bill  : <b>{billNum2}</b></Form.Label>
                                    </Col>
                                </Row>
                            }
                            <Row>

                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={crLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={(value) => handleCrLocationChange(value)}
                                            isDisabled={branchDisable === "true" || scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Cr/Dr<span className="text-danger">*</span></Form.Label>
                                        <Form.Select disabled={scrMode === "Q"} value={crFlag} onChange={(e) => handleCrFlagChange(e.target.value)} required>
                                            <option value="C">Credit</option>
                                            <option value="D">Debit</option>
                                        </Form.Select>
                                    </Form.Group>

                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={crLedgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, crLocationCode)} // location = 1 , 2
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleCrLedgerValue}
                                            isDisabled={scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6' style={{ textAlign: "right" }}>
                                    <Form.Label>Amount<span className="text-danger">*</span></Form.Label>
                                    <Form.Group>
                                        <Form.Control
                                            value={crKnockoffAmount}
                                            maxLength={Common.maximumLength}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setCrKnockoffAmount)}
                                            placeholder="Amount"
                                            disabled={scrMode === "Q"}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                scrMode !== "Q" &&
                                <>
                                    <Row>
                                        <Col className='col-12'>
                                            <Form.Group>
                                                <Form.Label>Knockoff<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={crKnockoffValue}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchKnockoffPicklist(search, crLocationCode, `${crFlag}^${crGrpCode}^${crAccCode}^${Common.dateYMD(nDate)}^${randomNum}`)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleCrKnockoffValue}
                                                    formatOptionLabel={Picklist.knockOffFormatOptionLabel}
                                                    components={{ Menu: Picklist.knockkOffMenu }}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Narration : {crKnockoffValue?.label?.split(' ')[7]?.split(':')[1]?.split("^")?.join(' ')}
                                            <span className='colorThemeBlue' onClick={() => copyNarrationValue(crKnockoffValue)}>
                                                <FontAwesomeIcon icon={faCopy} />
                                            </span>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className="col-md-3 col-6">
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleAdd} >Add</Button>&nbsp;
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                {/* {showBooklist ?/ */}
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <td colSpan={4}></td>
                                            <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Debit:</b> <span>{Math.abs(totalDebit)}</span></td>
                                            <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Credit:</b> <span>{Math.abs(totalCredit)}</span></td>
                                        </tr>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Location</th>
                                            <th>Type</th>
                                            <th>Srno</th>
                                            <th style={{ textAlign: 'right' }}>Debit</th>
                                            <th style={{ textAlign: 'right' }}>Credit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            bookList.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="textCenter" >
                                                        {userRight.query === "1" && (scrMode == 'E' || scrMode == 'A') && item.delny == "Y" ?
                                                            <span className="handCursor colorThemeBlue"
                                                                onClick={() => handleDelete(item)}>
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </span>
                                                            : null
                                                        }
                                                    </td>
                                                    <td>{item.tfd_location}</td>
                                                    <td>{item.tfd_type}</td>
                                                    <td>{item.tfd_srno}</td>
                                                    <td style={{ textAlign: 'right' }}>{item.tfd_flag == 'D' && Math.abs(item.tfd_amount).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{item.tfd_flag == 'C' && Math.abs(item.tfd_amount).toFixed(2)}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                    <br /><br />
                                </Table>
                                {/* : null} */}
                            </Row>
                            <Row>
                                <Col className='col-md-8 col-12'>
                                    <Form.Group>
                                        <Form.Label>Narration<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control disabled={scrMode === "Q"} as="textarea" rows={2} maxLength={1000} value={narration} onChange={e => Common.validateAlpNumSplValue(e.target.value, setNarration)} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>&nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                            </>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                        </>
                }
            </Container >
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
        </>
    )
}

export default Tran_cross_knockoff_updated
